import { GlobalBase } from './global-base.js';
import { GestureEventListeners } from '@polymer/polymer/lib/mixins/gesture-event-listeners.js';
import * as Gestures from '@polymer/polymer/lib/utils/gestures.js';

class DbqFeedbackSidebar extends GestureEventListeners(GlobalBase) {
  static get is() {
    return 'dbq-feedback-sidebar';
  }

  ready() {
    super.ready();
    this.makeDraggable();
    this.setupForms();
    this.setupSelectAll();
    this.querySelector('.minimize-toggle').addEventListener('click', this.toggleMinimize);
    // save the open state of the sidebar in the browser local storage
    // Restore the open state of the sidebar from local storage
    const sidebarOpen = window.localStorage.getItem('sidebarOpen');
    if (sidebarOpen === 'true') {
      document.getElementById('minimizeContainer').style.display = 'block';
      document.getElementById('toggleSvg').style.transform = "rotate(180deg)";
      document.getElementById('toggleSvg').style.marginTop = "-4px";
      document.getElementById('toggleSidebar').style.width = "200px";
      this.setAttribute('aria-label', 'Click to minimize the student sidebar');
    } else {
      document.getElementById('minimizeContainer').style.display = 'none';
      document.getElementById('toggleSvg').style.transform = "rotate(0deg)";
      document.getElementById('toggleSvg').style.marginTop = "0px";
      document.getElementById('toggleSidebar').style.width = "160px";
      this.setAttribute('aria-label', 'Click to open the student sidebar');
    }

  }

   toggleMinimize(event) {
    var toggleEl = document.getElementById('minimizeContainer');
    var toggleSvg = document.getElementById('toggleSvg');
    var toggleSidebar = document.getElementById('toggleSidebar');

    if(toggleEl.style.display == 'block') {
        toggleEl.style.display = 'none';
        toggleSvg.style.transform = "rotate(0deg)";
        toggleSvg.style.marginTop = "0px";
        toggleSidebar.style.width = "160px";
        this.setAttribute('aria-label', 'Click to open the student sidebar');
        window.localStorage.setItem('sidebarOpen', 'false');
    }
    else if(toggleEl.style.display == 'none') {
        toggleEl.style.display = 'block';
        toggleSvg.style.transform = "rotate(180deg)";
        toggleSvg.style.marginTop = "-4px";
        toggleSidebar.style.width = "200px";
        this.setAttribute('aria-label', 'Click to minimize the student sidebar');
        window.localStorage.setItem('sidebarOpen', 'true');
    }
    else {
        toggleEl.style.display = 'none';
        toggleSvg.style.transform = "rotate(0deg)";
        toggleSvg.style.marginTop = "0px";
        toggleSidebar.style.width = "160px";
        this.setAttribute('aria-label', 'Click to open the student sidebar');
        window.localStorage.setItem('sidebarOpen', 'false');
    }
    return;
}

  setupSelectAll(){
    this.querySelector('#allSutdents').addEventListener('click', (event)=>{
    // console.log("DbqFeedbackSidebar -> setupSelectAll -> event", event.target)
      this.querySelectorAll('input').forEach((el)=>{
        if(!el.checked){el.click();}
      });
    })
  }

  makeDraggable(){
    // console.log("DbqFeedbackSidebar -> makeDraggable -> makeDraggable")
    this.getCurrentPosition();
    this.updatePostionResize();
    Gestures.addListener(this,'track', this.updatePostion.bind(this));
    window.addEventListener('resize', this.updatePostionResize.bind(this));
  }

  getCurrentPosition(){
    let top = window.localStorage.getItem('cheklistTop');
    let left = window.localStorage.getItem('cheklistLeft');

    if(top){
      this.style.top = top;
    }
    if(left){
      this.style.left = left;
    }
    this.removeAttribute('hidden');
  }

  setCurrentPosition(){
    window.localStorage.setItem('cheklistTop', window.getComputedStyle(this).top);
    window.localStorage.setItem('cheklistLeft', window.getComputedStyle(this).left);
  }

  updatePostion(event){
    event.stopPropagation();

    if (event.detail.state === 'track') {
      // console.log("DbqFeedbackSidebar -> updatePostion -> event",  event.detail.ddx)
      if(event.detail.ddx === 0){return;}
      let newLeft = parseInt(window.getComputedStyle(this).left) + event.detail.ddx;
      let newTop = parseInt(window.getComputedStyle(this).top) + event.detail.ddy;
      let width = parseInt(window.getComputedStyle(this).width)
      let viewPortWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );

      newLeft = newLeft < 0 ? 0 : newLeft;
      newTop = newTop < 0 ? 0 : newTop;
      newLeft = (newLeft + width) > viewPortWidth ? viewPortWidth - width : newLeft;

      this.style.top = newTop + 'px';
      this.style.left =  newLeft + 'px';
    }

    if (event.detail.state === 'end') {
      this.setCurrentPosition();
    }
  }

  updatePostionResize(event){
    // console.log("DbqFeedbackSidebar -> updatePostionResize -> event", event)
    let newLeft = parseInt(window.getComputedStyle(this).left);
    let width = parseInt(window.getComputedStyle(this).width)
    let viewPortWidth = Math.max(
      document.documentElement.clientWidth,
      window.innerWidth || 0
    );

    newLeft = newLeft < 0 ? 0 : newLeft;
    newLeft = (newLeft + width) > viewPortWidth ? viewPortWidth - width : newLeft;
    this.style.left = newLeft + 'px';
  }

  setupForms(){
    this.querySelectorAll('form input').forEach((el)=>{
      // console.log("DbqFeedbackSidebar -> ready -> el", el)
        el.addEventListener('change',this.formEvent.bind(this));
      });
  }

  formEvent(event){
    // console.log("DbqFeedbackSidebar -> ready -> event", event)
      let form = event.target.closest('form')
      let formData = new FormData(form);

      var object = {};
      formData.forEach((value, key) => {object[key] = value});
      var json = JSON.stringify(object);

      fetch(form.getAttribute('action'), {
        method: 'POST',
        body: json,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': this.token
        },
        credentials: 'same-origin'
      }).then(
        (response) => {
          var returnVal;
          if (response.status !== 200) {
            returnVal = response;

          } else {
            returnVal = response.text();
          }
          return returnVal;
        },
        (error) => {
          return error.message;
        }
      ).then((data) => {
        // console.log("DbqFeedbackSidebar -> ready -> data", data)
        // this.course.hidden = !this.course.hidden;
        return data;
      });

  }

}
customElements.define(DbqFeedbackSidebar.is, DbqFeedbackSidebar);
